import MuiFormControl, { FormControlProps } from '@mui/material/FormControl';

export interface IFormControlProps extends FormControlProps {}

const FormControl = (props: IFormControlProps): JSX.Element => {
  return <MuiFormControl {...props} />;
};

export default FormControl;
